import { render } from "./productDetail.vue?vue&type=template&id=1d9df684&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"

import "./productDetail.vue?vue&type=style&index=0&id=1d9df684&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9df684"]])

export default __exports__